// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__4qxxU","colCheckbox":"styles_colCheckbox__P2hLf"};